<div class="tile">

  <!-- Spinner while loading -->
  <ng-container *ngIf="!initialized">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="initialized">
    <div *ngIf="mode === UserBoardComponentMode.Edit" class="bottom-spacing">
      <div class="first-input-row">
        <!-- Header Input -->
        <mat-form-field class="w-full" appearance="fill">
          <mat-label>Pie Chart Header</mat-label>
          <input matInput [(ngModel)]="model.header" />
        </mat-form-field>
      </div>

      <!-- Group By Toggle -->
      <div class="flex items-center gap-2 mb-4">
        <mat-slide-toggle 
          [(ngModel)]="model.useGroupBy" 
          (change)="onUseGroupByToggle($event.checked)">
          Group data by dataset field
        </mat-slide-toggle>
        <span class="text-sm text-gray-600">
          {{ model.useGroupBy ? 'Data will be grouped by a field from a dataset' : 'Show metrics as individual slices' }}
        </span>
      </div>

      <!-- Group By Configuration (only shown when Group By is enabled) -->
      <div *ngIf="model.useGroupBy" class="mb-4">
        <!-- Dataset Selection -->
        <mat-form-field class="w-full mb-4" appearance="fill" *ngIf="datasets.length > 0 && model.groupBy">
          <mat-label>GroupBy Dataset</mat-label>
          <mat-select [(ngModel)]="model.groupBy.datasetId" (selectionChange)="onDatasetChange($event.value)">
            <mat-option *ngFor="let dataset of datasets" [value]="dataset.datasetReferenceTable.datasetId">
              {{ dataset.datasetReferenceTable.datasetName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Field to Display (conditionally shown after dataset selection) -->
        <mat-form-field class="w-full" appearance="fill" *ngIf="availableFields.length > 0 && model.groupBy">
          <mat-label>Field To Display</mat-label>
          <mat-select [(ngModel)]="model.groupBy.fieldToDisplay" (selectionChange)="onFieldChange($event.value)">
            <!-- Special option for PrimaryKey -->
            <mat-option *ngIf="showPrimaryKey()"
              [value]="getPrimaryKeyValue()">
              Primary Key
            </mat-option>

            <!-- Normal fields -->
            <mat-option *ngFor="let field of availableFields" [value]="field.fieldName">
              {{ field.fieldName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Display Mode Selection (hidden for now - only Single Pie Chart supported) -->

      <!-- Add Metric Section -->
      <div class="space-y-2">
        <!-- Add Metric -->
        <div class="flex gap-4 items-end">
          <mat-form-field class="flex-1" appearance="fill">
            <mat-label>Select Metric</mat-label>
            <mat-select [(ngModel)]="selectedMetric">
              <mat-option *ngFor="let metric of availableMetrics" [value]="metric">
                {{ metric.metricName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-32" appearance="fill">
            <mat-label>Color</mat-label>
            <input matInput type="color" [(ngModel)]="selectedColor" />
          </mat-form-field>

          <mat-form-field class="w-40" appearance="fill" *ngIf="model.displayMode === PieChartDisplayMode.MetricGroups && !model.useGroupBy">
            <mat-label>Group Name (Optional)</mat-label>
            <input matInput [(ngModel)]="selectedGroupName" placeholder="e.g., Revenue Components" />
          </mat-form-field>

          <button 
            mat-raised-button 
            color="primary"
            (click)="onMetricAdd(selectedMetric, selectedColor, selectedGroupName || undefined)"
            [disabled]="!selectedMetric"
            class="h-14">
            <mat-icon>add</mat-icon>
            {{ model.useGroupBy && model.metrics.length > 0 ? 'Replace Metric' : 'Add Metric' }}
          </button>
        </div>

        <!-- Constraint Information -->
        <div *ngIf="model.useGroupBy" class="mt-2 p-3 bg-blue-50 border border-blue-200 rounded">
          <div class="flex items-start gap-2">
            <mat-icon class="text-blue-600 text-base">info</mat-icon>
            <div class="text-sm text-blue-800">
              <div class="font-medium">Group By Mode Constraints:</div>
              <ul class="mt-1 list-disc list-inside space-y-1">
                <li>Only one metric allowed (shows distribution of that metric across groups)</li>
                <li>{{ model.metrics.length > 0 ? 'Adding another metric will replace the current one' : 'Add a metric to see data grouped by your selected field' }}</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Display Added Metrics -->
        <div *ngIf="model.metrics.length > 0" class="mt-4">
          <h3 class="text-lg font-semibold mb-2">Added Metrics</h3>
          <div class="space-y-2">
            <div *ngFor="let metric of model.metrics; let i = index" 
                 class="flex items-center gap-2 p-2 bg-gray-50 rounded">
              <div class="w-6 h-6 rounded" [style.background-color]="metric.color"></div>
              <div class="flex-1">
                <div class="font-medium">{{ metric.metric.metricName }}</div>
                <div *ngIf="metric.groupName" class="text-sm text-gray-600">
                  Group: {{ metric.groupName }}
                </div>
              </div>
              <button mat-icon-button color="warn" (click)="onMetricRemove(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart Display -->
    <div class="chart-container" [class.edit-mode]="mode === UserBoardComponentMode.Edit">
      <h2 class="chart-header" *ngIf="model.header">{{ model.header }}</h2>
      <p-chart 
        type="pie" 
        [data]="chartData" 
        [options]="chartOptions"
        [style]="{'width': '100%', 'height': '100%'}"
        [responsive]="true">
      </p-chart>
    </div>

    <!-- Preview Button -->
    <div *ngIf="mode === UserBoardComponentMode.Preview" class="preview-buttons">
      <button mat-icon-button (click)="onPreviewButtonClick('edit')">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button (click)="onPreviewButtonClick('delete')">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
</div>